import React from 'react';
import { Meteor } from 'meteor/meteor';

import {
  Col,
  BPanel,
  FormControl,
  FormGroup,
  ControlLabel,
  Checkbox,
  Well,
  Button,
  Radio
} from '@sketchpixy/rubix';

import { Flights } from '../../../collections/flights-type/flights-type';
import { Prices } from '../../../collections/flights-type/prices';

export class TotalPriceComponent extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};
		this.calculPrice = this.props.calculPrice;
	}

	renderPrice() {
		return (
			<Button bsStyle="warning">{this.calculPrice()}€</Button>
		);
	}

	render() {
		return (
			<center>
				{this.renderPrice()}
				<hr/>
				<FormControl componentClass="select" type="select" ref={this.props.livraisonType}>
					<option value="1">Billet seul</option>
					<option value="2">Billet + Facture</option>
				</FormControl>
				<hr/>
				<FormGroup>
					<Button type="submit">
						Enregistrer
					</Button>
				</FormGroup>
			</center>
		);
	}
}




/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/components/component-total-price.js
 **/